import { createSelector } from "reselect";
import { getEntities, getResults } from "reducers";
import Immutable from "immutable";
import { denormalize } from "normalizr";
import { exchange } from "schemas";

// eslint-disable-next-line import/prefer-default-export
export const getExchange = createSelector(
  (state) => getResults(state).get("exchange", Immutable.List()),
  (state) => getEntities(state),
  (result, entities) =>
    denormalize(result, exchange.arrayOfExchangeSchemas, entities)
);
